const containerCls = "_n29c15ds0lr";
const shapeCls = "_n29sovcj2a";

export { containerCls, shapeCls };
import "./Shape.style.linaria.module.css";
//# sourceMappingURL=Shape.style.js.map
